import React from 'react';

interface CountdownOverlayProps {
  remainingSeconds: number;
}

export const CountdownOverlay: React.FC<CountdownOverlayProps> = ({
  remainingSeconds,
}) => {
  if (remainingSeconds <= 0) return null;

  return (
    <div
      className="absolute inset-0 flex items-center justify-center pointer-events-none z-50 bg-black/40 backdrop-blur-xs transition-opacity duration-200"
      aria-live="assertive"
      aria-label={`Countdown ${remainingSeconds} seconds`}
    >
      <div className="flex flex-col items-center">
        <span className="text-8xl sm:text-9xl md:text-[14rem] font-bold text-white tracking-wider animate-pulse drop-shadow-2xl">
          {remainingSeconds}
        </span>
        <span className="text-sm text-neutral-400 mt-4 tracking-widest uppercase">
          Press Space to cancel
        </span>
      </div>
    </div>
  );
};
